import React from "react";
import { Card } from "antd";

const PageBanner = ({ icon, title, description, children, className = "" }) => (
  <Card className={`mb-4 bg-white text-primary rounded-lg px-4 ${className}`}>
    <div className="flex items-center">
      {icon && <div className="text-2xl text-primary mr-6">{icon}</div>}
      <div>
        <h1 className="font-semibold text-lg m-0 text-primary">{title}</h1>
        {description && <p className="text-gray-500 m-0">{description}</p>}
        {children}
      </div>
    </div>
  </Card>
);
export default PageBanner;